import React from "react";
import { Link } from "gatsby";
import LogoWhite from "../../svgs/LogoWhite";
import FacebookIcon from "../../svgs/FacebookIcon";
import LinkedinIcon from "../../svgs/LinkedinIcon";
import TwitterIcon from "../../svgs/TwitterIcon";
import "./styles.scss";

const SiteFooter = () => (
    <footer className="site-footer">
        <div className="inner site-footer__inner">
            <div className="site-footer__top">
                <div className="site-footer__company">
                    <LogoWhite />

                    <p className="site-footer__description">
                        Whole of market investment services focused on the
                        direct lending market
                    </p>
                    <ul className="site-footer__social">
                        <li className="site-footer__social-icon">
                            <a
                                href="https://facebook.com/orcamoney"
                                title="Like us on Facebook"
                            >
                                <FacebookIcon />
                            </a>
                        </li>
                        <li className="site-footer__social-icon">
                            <a
                                href="https://twitter.com/orca_money"
                                title="Follow us on Twitter"
                            >
                                <TwitterIcon />
                            </a>
                        </li>
                        <li className="site-footer__social-icon">
                            <a
                                href="https://www.linkedin.com/company/orca-money/"
                                title="Follow us on LinkedIn"
                            >
                                <LinkedinIcon />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="site-footer__nav">
                    <div className="site-footer__nav-col">
                        <h3 className="site-footer__nav-title">Company</h3>
                        <ul className="site-footer__nav-list">
                            <li className="site-footer__nav-item">
                                <Link to="/" title="Go back home">
                                    Home
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="site-footer__nav-col">
                        <h3 className="site-footer__nav-title">Blog</h3>
                        <ul className="site-footer__nav-list">
                            <li className="site-footer__nav-item">
                                <Link to="/learn/articles" title="Articles">
                                    Blog Articles
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="site-footer__nav-col">
                        <h3 className="site-footer__nav-title">Contact</h3>
                        <ul className="site-footer__nav-list">
                            <li className="site-footer__nav-item">
                                <a
                                    title="Email us"
                                    href="mailto:info@orcamoney.com"
                                >
                                    info@orcamoney.com
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="site-footer__nav-col">
                        <h3 className="site-footer__nav-title">Offices</h3>
                        <div className="site-footer__office site-footer__office--edinburgh">
                            <h4 className="site-footer__office-title">
                                Edinburgh
                            </h4>
                            <div className="site-footer__office-location">
                                38 Castle Terrace, EH3 9DZ
                            </div>
                        </div>
                        <div className="site-footer__office site-footer__office--belfast">
                            <h4 className="site-footer__office-title">
                                Belfast
                            </h4>
                            <div className="site-footer__office-location">
                                Catalyst Belfast Fintech Hub, Belfast, BT1 6JS
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="site-footer__bottom">
                <div className="site-footer__risk-statement">
                    {/* <p>
                        <b>Risk Warning</b> Peer to peer investing involves
                        lending money to people or businesses. This presents a
                        risk that the borrower defaults on their loan
                        commitment. When investing in P2P, your capital and
                        interest are at risk and are not covered by the
                        Financial Services Compensation Scheme (FSCS).
                    </p>
                    * Indicative rate calculated as a weighted blend of the
                    underlying P2P advertised rates. This is a gross rate which
                    will be subject to a annual 0.65% servicing fee after April
                    2020.
                    <p /> */}
                </div>
                <div className="site-footer__base">
                    <div className="site-footer__base-company">
                        © 2019 Orca Money Limited (No. NI635108)
                    </div>
                    {/* <ul className="site-footer__base-links">
                        <li className="site-footer__base-link">
                            <Link to="/terms" title="Terms">
                                Terms
                            </Link>
                        </li>
                        <li className="site-footer__base-link">
                            <Link to="/privacy" title="Privacy">
                                Privacy
                            </Link>
                        </li>
                    </ul> */}
                </div>
            </div>
        </div>
    </footer>
);

export default SiteFooter;
